<template>
  <div class="hospitalOrder">
    <div class="container">
      <div class="titleNav">
        <a href="">我要下单</a> /
        <router-link to="/medical">医疗服务</router-link>
        /
        <router-link to="/hospitalOrder">确定订单</router-link>
      </div>
      <div class="content">
        <div class="top">
          <div class="topInfo">
            <hospital-info/>
            <div v-for="(item, index) in doctorInfo" :key="index">
              <doctor-info :doctorInfo="item" :key="index"/>
            </div>
          </div>
          <div class="right">
            <p class="text">如果您指定的医生不出诊或无号源,是否同意就诊同科室的其他医生？</p>
            <div class="isAgree">
              <button :class="info.isAgree == 0 ? 'agree' : 'noAgree'" @click="changeAgree(0)">同意</button>
              <button :class="info.isAgree == 1 ? 'agree' : 'noAgree'" @click="changeAgree(1)">不同意</button>
            </div>
          </div>

        </div>
        <div class="middle">
          <div class="left">
            <div style="display: flex" ref="">
              <div>
                <label for="" v-for="(item, index) in timeList" :key="index">
                  <span>就诊时间：</span>
                  <div>
                    <el-date-picker
                            v-model="item.value"
                            type="date"
                            clearable
                            value-format="yyyy-MM-dd"
                            @change="times"
                            placeholder="选择日期">
                    </el-date-picker>
                    <el-button @click="handAm(item, 1)" :type="item.isAm ? 'primary' : ''">上午</el-button>
                    <el-button @click="handAm(item, 0)" :type="item.isAm ? '' : 'primary'">下午</el-button>
                  </div>
                  <!--<el-date-picker-->
                  <!--v-model="value1"-->
                  <!--@change="changeTime"-->
                  <!--type="datetimerange"-->
                  <!--range-separator="至"-->
                  <!--start-placeholder="开始日期"-->
                  <!--end-placeholder="结束日期">-->
                  <!--</el-date-picker>-->
                </label>
              </div>
              <el-button @click="addTime" style="height: 40px;margin-left: 5px;">添加时间</el-button>
            </div>
            <patient-info @info="childInfo"/>
          </div>
          <div class="right">
            <raise-price/>
          </div>
        </div>
        <div class="bottom">
          <router-link :to="{name: 'RichText', query: {code: '010'}}" class="plain">价格说明</router-link>
          <price-explain/>
          <button @click="pay">支付</button>
        </div>
      </div>
    </div>
    <pay-way v-if="isShowPay" @close="showPay"/>
  </div>
</template>

<script>
  import HospitalInfo from '../../../components/Hospital/HospitalInfo'
  import DoctorInfo from '../../../components/Hospital/DoctorInfo'
  import RaisePrice from '../../../components/Courier/RaisePrice'
  // import DateTime from '../../../components/Time'
  import PatientInfo from '../../../components/Hospital/PatientInfo'
  import PriceExplain from '../../../components/Courier/PriceExplain'
  import PayWay from '../../../components/Pay/PayWay'
  import {mobiles, idCard} from '../../../utils/phone'
  import {formatDate} from '../../../utils/date'
  import {reqCountServeFee, reqOrderDoctor} from '../../../api'
  import {mapState} from 'vuex'
import {reqPatientChange} from '../../../api'
  export default {
    data () {
      return {
        info: {
          patientid: '',
          name: '',
          sex: 0, //性别
          phone: '', // 手机号
          idCard: '', // 身份证
          description: '', // 备注
          accountInfo: '', // 账户信息
          serviceDate: '', // 服务有效期
          paytype: '', // 付款方式
             jiuyiNo:"", //医保信息
          visitDate: '', // 就诊时间
          barCode:"", //医院条码
          isAgree: 0, // 1：不同意 0:同意"
        },
        timeList: [{value: '', isAm: 1}], // 1 上午  0  下午
        value1: '',
        sex: 0,
        // type: 'datetime', // 时间类型
        isShowPay: false // 显示支付宝
      }
    },
    created () {
      if (JSON.stringify(this.hospitalInfo) == '{}') {
        this.$router.replace('/courier/medical')
      }
    },
    mounted () {
    },
    methods: {
      // 添加时间
      addTime() {
        this.timeList.push({value: '', isAm: 1})
      },
      // 选中上下午
      handAm(item, i) {
        item.isAm = i
        if(item.value) {
          this.times()
        }
      },
      // 根据时间和医生id计算价格
      times () {
        let times = ''
        this.timeList.forEach((item, index) => {
          if(item.isAm) {
            times += item.value + ' 08:00:00' + ','
          } else {
            times += item.value + ' 14:00:00' + ','
          }
        })
        this.info.visitDate = times
        let doctorId = ''
        this.doctorInfo.forEach((item, index) => {
          if (index == this.doctorInfo.length - 1) {
            console.log(item.id)
            doctorId += item.id
          } else {
            doctorId += item.id + ','
          }
        })
        let query = `?doctorIds=${doctorId}&visitDates=${this.info.visitDate}`
          reqCountServeFee(query).then(res => {
            if (res.code === 200) {
              this.$store.dispatch('getFee', res.data.bussData)
            }
          })
      },
      // 点击是否同意
      changeAgree (i) {
        this.info.isAgree = i
        this.$forceUpdate() // $forceUpdate可以迫使 Vue 实例重新渲染。它仅仅影响实例本身和插入插槽内容的子组件，而不是所有子组件。
      }
      ,
      // 选择性别
      handleClick (i) {
        this.sex = i
      }
      ,
      // 接收孩子的信息
      childInfo (info) {
        this.info = Object.assign(info, this.info)
      }
      ,
      // 显示支付方式
      showPay () {
        this.isShowPay = !this.isShowPay
      }
      ,
      // 支付
      pay () {
        if (!this.info.visitDate) {
          this.$message({
            message: '就诊时间不能为空',
            type: 'error'
          })
        } else if (!this.info.name) {
          this.$message({
            message: '就诊人不能为空',
            type: 'error'
          })
        } else if (!this.info.phone) {
          this.$message({
            message: '就诊人手机号不能为空',
            type: 'error'
          })
        } else if (!mobiles(this.info.phone)) {
          this.$message({
            message: '就诊人手机号不正确',
            type: 'error'
          })
        } else if (!this.info.idCard) {
          this.$message({
            message: '就诊人身份证号不能为空',
            type: 'error'
          })
        } else if (!this.info.serviceDate) {
          this.$message({
            message: '服务时间不能为空',
            type: 'error'
          })
        } else if (this.info.paytype === '') {
          this.$message({
            message: '请选择付款方式',
            type: 'error'
          })
        } else {
          console.log(this.doctorInfo)
          let doctorId = ''
          let doctor = ''
          let department = ''
          this.doctorInfo.forEach((item, index) => {
            if (index == this.doctorInfo.length - 1) {
              console.log(item.id)
              doctorId += item.id
              doctor += item.name
              department = item.departmentName
            } else {
              doctorId += item.id + ','
              doctor += item.name + ','
            }
          })
          if(department == ''){
            department = this.$route.query.departmentIdAName + " "+ this.$route.query.departmentIdBName
          }
          const {hospital, patientid, name, sex, phone,idCard, description, barCode,accountInfo, serviceDate, paytype, visitDate, isAgree} = this.info
          let body = {}
          console.log(doctorId)
          if (patientid) {
            body = {
              barCode,
              doctorId, // 医生id
              doctor, // 医生姓名
              department, // 科室名称
              hospital: this.hospitalInfo.name, // 医院名称
              hospitalIds: this.hospitalInfo.id,
              hospitalid: this.hospitalInfo.id,
              patientid,
              description,
              accountInfo,
              serviceDate,
              paytype,
              visitDate,
              isAgree,
              addFee: this.addFee,
              couponId: this.amount.couponId,
              origin: 1,
              departmentAid : this.$route.query.departmentIdA,
	            departmentBid : this.$route.query.departmentIdB,
            }
          } else {
            body = {
              barCode,
              doctorId,
              doctor,
              department,
              hospital: this.hospitalInfo.name,
              hospitalIds: this.hospitalInfo.id,
              hospitalid: this.hospitalInfo.id,
              name,
              sex,
              phone,
              idCard,
              description,
              accountInfo,
              serviceDate,
              paytype,
              visitDate,
              isAgree,
              addFee: this.addFee,
              couponId: this.amount.couponId,
              origin: 1,
              departmentAid : this.$route.query.departmentIdA,
	            departmentBid : this.$route.query.departmentIdB,
            }
          // todo 如果是新建 就增加一个人
           reqPatientChange({
            mobile:body.phone,
            jiuyiNo:accountInfo,
            barCodes:this.info.barCode,
             ...body
           }).then(res => {
            console.log(res)
          })
          }
          console.log(body)
          reqOrderDoctor(body).then(res => {
            console.log(res)
            if (res.code === 200) {
              this.showPay()
              this.$store.dispatch('getOrderInfo', res.data.bussData)
            }
          })
        }
      }
    },
    computed: {
      ...mapState(['doctorInfo', 'hospitalInfo', 'addFee', 'amount'])
    },
    components: {
      HospitalInfo,
      DoctorInfo,
      RaisePrice,
      // DateTime,
      PatientInfo,
      PriceExplain,
      PayWay
    }
  }
</script>

<style scoped lang="less" type="text/less">
  .hospitalOrder {
    margin-bottom: 43px;

    .titleNav {
      margin: 30px 0 41px;
    }

    .content {
      padding: 30px;
      box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.09);

      .top {
        padding-bottom: 30px;
        border-bottom: 1px solid #e1e1e1;

        .topInfo {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
        }

        .right {
          .text {
            margin: 20px 0;
          }

          .isAgree {
            button {
              width: 80px;
              height: 39px;
              border: none;
              border-radius: 20px;
              box-sizing: border-box;
              margin-right: 20px;
              cursor: pointer;

              &.agree {
                background: #2FA1DE;
                color: #fff;
              }

              &.noAgree {
                background: #fff;
                color: #333;
                border: 1px solid #e1e1e1;
              }
            }
          }
        }
      }

      .middle {
        display: flex;
        justify-content: space-between;
        margin-top: 40px;
        padding-bottom: 30px;
        border-bottom: 1px solid #e1e1e1;

        .left {
          label {
            display: flex;
            margin-bottom: 20px;
            line-height: 40px;

            span {
              width: 112px;
              margin-right: 5px;
              text-align: right;
            }
          }

          .infuse {
            color: #999;
            margin-left: 119px;
            margin-bottom: 20px;
          }
        }
      }

      .bottom {
        margin-top: 29px;

        .plain {
          color: #2FA1DE;
          text-decoration: underline;
        }

        button {
          width: 332px;
          height: 48px;
          margin-top: 30px;
          margin-left: 237px;
          border: none;
          background: #61aee6;
          color: #fff;
          box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.15);
          border-radius: 24px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Courier/Hospital/HospitalOrder.vue